export const getErrorAPIMessage = (error) => {
  const message =
    error?.response?.data?.detail?.[0]?.msg ||
    error?.response?.data?.detail ||
    error?.message ||
    "Something went wrong. Please try again.";

  return message;
};
